import React from 'react';

import { buildWebsiteUrl } from '@repo/utils/url';

import DecisionModal from '../../DecisionModal/DecisionModal';
import { DecisionModalProps } from '../../DecisionModal/types';

const InactiveTeamAccountModal: React.FC<
  Pick<DecisionModalProps, 'isOpen' | 'onClose'>
> = ({ isOpen, onClose }) => {
  return (
    <DecisionModal
      firstButton={{
        label: 'Contact Support',
        onClick: (): void => {
          window.open(buildWebsiteUrl('/contact'), '_blank');
        },
        width: 'auto',
        type: 'primary',
      }}
      isOpen={isOpen}
      message="There was an issue while creating your team account. Please contact support."
      title="Team Account Unfinished"
      onClose={onClose}
    />
  );
};

export default InactiveTeamAccountModal;
